// extracted by mini-css-extract-plugin
export default {"root":"RandomAvatarIcon_root__FxB9b","adaptive":"RandomAvatarIcon_adaptive__+3uju"};